import $ from 'jquery';
import {useState, createRoot, render} from '@wordpress/element';
import {Modal, Button, Flex, FlexItem} from '@wordpress/components';
import {ThreeDSTable} from "../components";

const ThreeDSModal = ({root, data, i18n}) => {
    const [open, setOpen] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [value, setValue] = useState(data);
    const onClose = () => {
        setOpen(false);
        root.unmount();
    };

    const onChange = (key, value) => {
        setValue(prev => {
            let entry = prev.find(entry => entry.key === key);
            if (entry) {
                entry.value = value;
            }
            return [...prev];
        });
        $(document.body).triggerHandler('wc_ppcp_3ds_config_change', {key, value});
    }

    const onSave = () => {
        setProcessing(true);
        $(document.body).triggerHandler('wc_ppcp_card_settings_save');
    }

    const onReset = () => {
        setValue(prev => {
            prev = prev.map(entry => ({
                ...entry,
                value: entry.default_value
            }));
            return [...prev];
        });
        $(document.body).triggerHandler('wc_ppcp_3ds_config_reset');
    }

    if (open) {
        return (
            <Modal
                title={'3DS Settings'}
                className={'wc-ppcp-3ds-modal'}
                onRequestClose={onClose}>
                <Flex direction={'column'}>
                    <FlexItem>
                        <p className={'threeds-config-desc'}>{i18n.description}</p>
                        <span dangerouslySetInnerHTML={{__html: i18n.desc2}}/>
                    </FlexItem>
                    <FlexItem>
                        <ThreeDSTable onChange={onChange} value={value} i18n={i18n}/>
                    </FlexItem>
                </Flex>
                <div className={"components-modal__footer"}>
                    <Flex direction={'row'}>
                        <Flex>
                            <Flex
                                direction={'row'}
                                justify={'flex-start'}>
                                <Button
                                    variant={'secondary'}
                                    onClick={onReset}>
                                    {i18n.reset}
                                </Button>
                            </Flex>
                        </Flex>
                        <Flex
                            direction={'row'}
                            justify={'flex-end'}>
                            <Button
                                variant={'secondary'}
                                onClick={onClose}>
                                {i18n.cancel}
                            </Button>
                            <Button
                                variant={'primary'}
                                onClick={onSave}
                                isBusy={processing}
                                disabled={processing}>
                                {i18n.save}
                            </Button>
                        </Flex>
                    </Flex>
                </div>
            </Modal>
        );
    }
}

ThreeDSModal.render = (el, {value, i18n}) => {
    if (createRoot) {
        const root = createRoot(el);
        root.render(<ThreeDSModal root={root} data={value} i18n={i18n}/>)
    }
}

export default ThreeDSModal;